import { Component, OnInit } from '@angular/core';
import { ButtonDisableDirective } from 'utils/directives/helper/button-disable';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-terms-modal',
  templateUrl: './terms-modal.component.html',
  styleUrls: ['./terms-modal.component.scss'],
  imports: []
})
export class TermsModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onAgree() {
    this.activeModal.close('agreed');
  }


}
